// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__T6XI1","wrapper":"styles_wrapper__dhfwF","title":"styles_title__yHMFc","projectCards":"styles_projectCards__D_fpJ"};
module.exports.__checksum = "988c0c41deb9"